module.exports = __webpack_public_path__ + "img/footprints - boromir.873cd68d.svg";